import { createContext, useContext, ReactNode } from 'react';
import shallow from 'zustand/shallow';
import { UseStore } from 'zustand';

import type { State, TypedUseSelectorHook } from '@hotjar/recordings/src/store/player/types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const StoreContext = createContext<UseStore<State>>(null);

export const useStore = (): UseStore<State> => useContext(StoreContext);
export const useStoreState = (): State => useContext(StoreContext).getState();
export const useSelector: TypedUseSelectorHook<State> = (selector, equalityFn) =>
  useContext(StoreContext)(selector, equalityFn ? equalityFn : shallow);

export const StoreProvider = ({
  store,
  children,
}: {
  store: UseStore<State>;
  children: ReactNode;
}): JSX.Element => <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
